import { usePosts } from '@/hooks/usePosts';
import { usePostsActions } from './usePostsActions';
import PostsManagerView from './postsmanager.view';

const PostsManager = () => {
  const { data: postsList = [], isLoading: loading } = usePosts();
  const actions = usePostsActions();

  return (
    <PostsManagerView
      postsList={postsList}
      loading={loading}
      isDialogOpen={actions.isDialogOpen}
      setIsDialogOpen={actions.setIsDialogOpen}
      editingPost={actions.editingPost}
      setEditingPost={actions.setEditingPost}
      formData={actions.formData}
      setFormData={actions.setFormData}
      handleEdit={actions.handleEdit}
      handleDelete={actions.handleDelete}
      handleSubmit={actions.handleSubmit}
      deleteTarget={actions.deleteTarget}
      setDeleteTarget={actions.setDeleteTarget}
      confirmDelete={actions.confirmDelete}
    />
  );
};

export default PostsManager;
